"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.run_fire = void 0;
var voyageGameStatus_enemyShips_sidecar_1 = require("@voyage/game-status/voyageGameStatus_enemyShips-sidecar");
function run_fire() {
    voyageGameStatus_enemyShips_sidecar_1.voyageGameStatus_enemyShips.hitByWeapon(0.9, 100, 0, false);
}
exports.run_fire = run_fire;
